module.exports = __webpack_public_path__ + "static/img/logo.c182009.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_icon_v4.0/logo.png
// module id = /yFh
// module chunks = 2